import { ReactNode } from 'react';

const SudoNoArg = (): ReactNode => <p>Usage: sudo [command]</p>;

const SudoNotFound = ({ command }: { command: string }): ReactNode => <p>sudo: {command}: Command not found</p>;

export { SudoNoArg, SudoNotFound };
